export default __webpack_public_path__ + "static/media/foto_brief.0d17d5f0.png";